<template>
	<header class="header">
		<button
			class="header__tab"
			:class="{ hidden }"
			@click.stop="$emit('click')"
		>
			<IconHome />
			<img
				class="header__tab__logo"
				src="@/assets/hiq-blue.svg"
				alt="okhiq logo"
			/>
		</button>
	</header>
</template>

<script>
import IconHome from 'mdi-vue/Home'

export default {
	name: 'hiq-header',
	computed: {
		hidden() {
			return this.$route.name === 'Home'
		}
	},
	components: {
		IconHome
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/components';

.header {
	height: 5rem;
	flex-shrink: 0;

	&__tab {
		display: inline-flex;
		align-items: center;
		appearance: none;
		border: none;
		height: 3rem;
		margin: 1rem 0;
		padding: 0.75rem;
		background-color: $white;
		transition: transform 0.25s $ease-out-sine;
		cursor: pointer;

		&:hover {
			background-color: $blue-98;
		}

		&.hidden {
			// Compensate for focus outline
			transform: translateX(calc(-100% - 2px));
		}

		// Home icon
		.mdi {
			@include square(1.5rem);
			margin-right: 0.75rem;
			color: $blue-73;
		}

		&__logo {
			height: 1.125rem;
			margin-right: 0.25rem;
		}
	}
}
</style>
